import React from "react"

import ItemModelV2 from "../../../../../../../model2/item2/item-model"
import FieldProto from "../../../../../../proto/field-proto"
import {ItemModelV2_CalculatedValues} from "../../../../../../../model2/item2/calculated/@type"
import {areJSONObjectPropsEqual} from "../../../../../../../gd/utils/compare"
import StatusSummaryBar from "../../../../../../generic/status/render/table/calculated/summary"
import TasksView_Column from "../../../../../../../model2/column/column"

type Props = {
    className?      : string
    style?          : any

    listItem        : ItemModelV2
    column          : TasksView_Column
    field           : FieldProto

    onMouseEnter    : callback
    onMouseLeave    : callback
}

// const debug = "FieldTaskStatus_TableCellCalculated_NotHovered"
const debug = false

export default function FieldTaskStatus_TableCellCalculated_NotHovered(props: Props) {

    const status = gd.session.statuses.get(props.listItem.task.statusId)
    if (!status) {
        return null
    }

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]
    const showSummaryView   = (/*props.listItem.isGroup ||*/ props.listItem.view.isCollapsed) &&
        calculatedValues?.total.summary &&
        !areJSONObjectPropsEqual(calculatedValues.total.summary,calculatedValues.own.summary)

    let notHoveredContent
    if (showSummaryView) {
        notHoveredContent = <StatusSummaryBar data={calculatedValues.total.summary!}/>
    } else {
        notHoveredContent = (
            <div className={Classes('ui5-status-list status-c{0}'.f(status.color), props.className)}>
                <div className="max-w-100-percent txt-truncate">{status?.name}</div>
            </div>
        )
    }

    const classes = Classes("cell-flex border-1px-transparent", {
        // 'is-expanded-calculated': props.listItem.isGroup && !props.listItem.view.isCollapsed
    })

    return (
        <div className      = {classes}
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}>
            {notHoveredContent}
        </div>
    )
}
